import script from "./GiftChipBar.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftChipBar.vue?vue&type=script&setup=true&lang=js"

import "./GiftChipBar.vue?vue&type=style&index=0&id=aa459cc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa459cc0"]])

export default __exports__